
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";
import { BlobResponse, ContentAndStatus } from '../../Models/OtherClasses';

@Injectable()
export class PhoneAppService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	) {
		this.url = urlService.getURL('PhoneApp');
	}

	getInstructions(lang: number): Observable<BlobResponse> {
		return this.myBaseService.loadBlob(this.url + '/AppInstructions/' + (lang || 0));
	}
	sendInstructions(lang: number): Observable<string> {
		return this.myBaseService.post(null, this.url + '/AppInstructions/' + (lang || 0), true);
	}

}

